<script setup lang="ts">
import { VChipGroup, VChip } from 'vuetify/components';

type ChipItemType = {
    value: string | number;
    title: string;
    disabled?: boolean;
    color?: string;
    variant?: VChip['$props']['variant'];
};

type PropsType = {
    items: ChipItemType[];
    multiple?: boolean;
    mandatory?: boolean;
    column?: boolean;
    filter?: boolean;
    variant?: VChipGroup['$props']['variant'];
    color?: string;
    selectedClass?: string;
    disabled?: boolean;
    chipSize?: VChip['$props']['size'];
};

withDefaults(defineProps<PropsType>(), {
    multiple: false,
    mandatory: false,
    column: false,
    filter: false,
    variant: 'tonal',
    color: 'primary',
    selectedClass: '',
    chipSize: 'default',
    disabled: false,
});

const selected = defineModel<(string | number)[] | string | number | null>('modelValue');

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VChipGroup
        v-model="selected"
        :multiple="multiple"
        :mandatory="mandatory"
        :column="column"
        :filter="filter"
        :selected-class="selectedClass"
        :disabled="disabled"
        class="b-chip-group"
        v-bind="$attrs"
    >
        <VChip
            v-for="item in items"
            :key="item.value"
            :value="item.value"
            :disabled="item.disabled || disabled"
            :color="item.color || color"
            :variant="item.variant || variant"
            :size="chipSize"
            class="b-chip-group__chip"
        >
            <slot
                name="chip"
                :item="item"
                :selected="Array.isArray(selected) ? selected.includes(item.value) : selected === item.value"
            >
                {{ item.title }}
            </slot>
        </VChip>
    </VChipGroup>
</template>
